// extracted by mini-css-extract-plugin
export default {"title":"title_title__DszOf","white":"title_white__WAxjW","black":"title_black__OeSHp"};